'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _PlusSquareOutlined = _interopRequireDefault(require('./lib/icons/PlusSquareOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _PlusSquareOutlined;
exports.default = _default;
module.exports = _default;